import styled, { css } from "styled-components";

export const AgendaContainer = styled.div`
    padding: 120px 0;


    background: rgb(6,155,250);
background: radial-gradient(circle, rgba(6,155,250,1) 0%, rgba(89,109,126,1) 100%);


    color: #fff;
    width: 100%;
`;

export const AgendaTitle = styled.h1`
    width: 100%;
    margin: 0 0 5vh 0;
    text-align: center;
    opacity: 10;
`;

export const AgendaWrap = styled.div``;

export const AgendaTabRow = styled.div`
    margin: 3vh 0;
    height: 100%;
    min-height: 5vh;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-around;
    gap: 5vh;
`;

export const AgendaTabButton = styled.button`
    border-radius: 50px;
    background-color: var(--impactColor);
    white-space: nowrap;
    padding: 14px 48px;
    font-size: 16px;
    outline: none;
    border: none;
    cursor: pointer;
    color: var(--primaryColor);
    font-weight: bold;
    transition: 0.3s ease-out;
    transform: translateY(0);
    align-self: center;

    &:hover {
        transition: 0.2s;
        transform: translateY(-5px);
        background-color: #fff;
    }

    ${(props) =>
        props.jueves === "true" &&
        css`
            background: #fff;
            transform: translateY(-5px);
        `}
    ${(props) =>
        props.viernes === "true" &&
        css`
            background: #fff;
            transform: translateY(-5px);
        `}
`;

export const AgendaEvents = styled.div`
    padding: 4vh 0;
`;

export const AgendaEvent = styled.div`
    min-height: 10vh;
    padding: 5vh 5vw;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    align-items: center;
    justify-items: center;
    margin: 2vh 0;
    border: solid var(--primaryColor);
    border-width: 2px 2px 0 0;
    row-gap: 3vh;
`;

export const AgendaTime = styled.span`
    height: fit-content;
    font-size: 2rem;
    padding: 0 10px;
    background: linear-gradient(
        135deg,
        rgba(255, 255, 255, 0.1),
        rgba(255, 255, 255, 0)
    );
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
    border-radius: 20px;
    border: 1px solid rgba(255, 255, 255, 0.18);
    box-shadow: 0 8px 32px 0 rgba(0, 0, 0, 0.37);
`;

export const AgendaEventDescription = styled.span`
    font-size: 1.5rem;
    text-align: center;
    padding: 0 10px;
    background: linear-gradient(
        135deg,
        rgba(255, 255, 255, 0.1),
        rgba(255, 255, 255, 0)
    );
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
    border-radius: 20px;
    border: 1px solid rgba(255, 255, 255, 0.18);
    box-shadow: 0 8px 32px 0 rgba(0, 0, 0, 0.37);
`;

export const AgendaSpeakerWrap = styled.div`
    height: 100%;
    display: flex;
    align-items: start;
`;

export const AgendaSpeakerUl = styled.ul`
    height: 100%;
    display: flex;
    gap: 1vh;
    flex-direction: column;
    align-items: start;
    justify-content: center;
`;

export const AgendaSpeakerLi = styled.li`
    list-style: none;
    padding: 0 10px;
    background: linear-gradient(
        135deg,
        rgba(255, 255, 255, 0.1),
        rgba(255, 255, 255, 0)
    );
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
    border-radius: 20px;
    border: 1px solid rgba(255, 255, 255, 0.18);
    box-shadow: 0 8px 32px 0 rgba(0, 0, 0, 0.37);
`;
